// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardDesign_wrapper__h5QfW","flex_h_center":"DashboardDesign_flex_h_center__JEYOq"};